import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AcademyTopPlayersService } from 'src/app/services/academy-top-players.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { environment } from 'src/environments/environment';
import { CustomValidators } from 'ng2-validation';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface, SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
@Component({
  selector: 'app-top-players',
  templateUrl: './top-players.component.html',
  styleUrls: ['./top-players.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class TopPlayersComponent implements OnInit {
  topplayersform: FormGroup;
  submitted = false;
  imageSize = environment.imageSize;
  uploadedFiles: any[] = [];
  id: string;
  pagetitle: string;
  isAdd: boolean = true;
  playerImage: any;
  public showingForm: boolean = false;
  loggedInAcademy;
  loggedInAcademyId;
  public loading: boolean;
  playerlist: any;
  errorMessage = '';
  item: any;
  playerid: any;
  topplayerimage: any;
  Imageplayer: any
  showUploadedpic: boolean = false;
  public disabled: boolean = false;
  public court_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',

    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    mousewheel: false,
    slidesPerView: 'auto',
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
    navigation: false,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  };
  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private playerservice: AcademyTopPlayersService,
    private messageService: MessageService,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {
    this.loggedInAcademy = this.tokenStorage.getUser();
    this.loggedInAcademyId = this.loggedInAcademy.userdata['academyId'];
    let academyPaymentDetails = this.loggedInAcademy.userdata.academyPaymentDetails;
    let roleName = this.loggedInAcademy.userdata.rolename;
    let currentUrl = '/';
    if (roleName == "academy") {
      if (Object.keys(academyPaymentDetails).length > 0) {
        if (academyPaymentDetails.academyPaymentStatus == 'created') {
          currentUrl = '/payment-history';
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([currentUrl]);
        }
      } else {
        currentUrl = '/payment-history';
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      }
    }
    this.topplayersform = this.formBuilder.group({
      playerName: ['', [Validators.required, Validators.pattern('^[A-Za-z ]*$')]],
      descriptions: [''],
      youtubeUrl: [null, [CustomValidators.url]],
      fbUrl: [null, [CustomValidators.url]],
      instagramUrl: [null, [CustomValidators.url]],
      skypeUrl: [null],
      linkedinUrl: [null, [CustomValidators.url]]
    }, { updateOn: "blur" });
    this.loadplayerlist();
  }

  get f() {
    return this.topplayersform.controls;
  }
  openmodal() {
    this.pagetitle = 'Add Top Players';
    this.Imageplayer = '';
    this.uploadedFiles = [];
    this.isAdd = true;
    this.showingForm = true;
    this.showUploadedpic = false;
    this.topplayersform.reset();
  }
  onHighlightModalClose() {
    this.showingForm = false;
  }
  onClickEdit(id) {
    this.pagetitle = 'Edit Top Players';
    this.isAdd = false;
    this.showingForm = true;
    this.getplayerdetails(id)
    console.log("id", id);
  }

  getplayerdetails(id) {
    this.playerservice.getAcademyTopPlayersDetails(id).subscribe(res => {
      this.item = res;
      this.playerid = id;
      this.topplayersform.controls.playerName.setValue(this.item.playerName);
      this.topplayersform.controls.descriptions.setValue(this.item.descriptions);
      this.topplayersform.controls.youtubeUrl.setValue(this.item.youtubeUrl);
      this.topplayersform.controls.fbUrl.setValue(this.item.fbUrl);
      this.topplayersform.controls.instagramUrl.setValue(this.item.instagramUrl);
      this.topplayersform.controls.skypeUrl.setValue(this.item.skypeUrl);
      this.topplayersform.controls.linkedinUrl.setValue(this.item.linkedinUrl);
      if (this.item['image'] != undefined) {
        this.Imageplayer = this.item['image'];
        this.showUploadedpic = true;
      } else {
        this.showUploadedpic = false;
      }
    })
  }
  loadplayerlist() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.loggedInAcademyId;
    this.playerservice.getAcademyTopPlayers(query).subscribe(
      data => {
        this.loading = false;
        this.playerlist = data.data.items;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  picUploader(event) {
    for (let file of event.files) {
      this.uploadedFiles.push(file);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // called once readAsDataURL is completed
        if (reader.result != null) {
          this.playerImage = reader.result;
        }
      }
    }
  }
  onsubmit() {
    this.submitted = true;
    if (this.topplayersform.invalid) {
      console.log("invalid");
      return;
    }
    var topplayerData = this.topplayersform.value;
    topplayerData['academyId'] = this.loggedInAcademyId;
    topplayerData['status'] = true;
    topplayerData['disable'] = false;
    if (this.isAdd) {
      topplayerData['image'] = this.playerImage;
      topplayerData = JSON.stringify(topplayerData, null, 4);
      this.addPlayer(topplayerData);
    } else {
      topplayerData['top_player_image'] = this.playerImage;
      topplayerData = JSON.stringify(topplayerData, null, 4);
      this.updatePlayer(topplayerData);
      console.log("edit");
    }
  }
  addPlayer(topplayerData) {
    this.playerservice.addAcademyTopPlayers(topplayerData).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Player Added', life: 6000 });
        setTimeout(() => {
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate(['/academies-profile/top-players']);
        }, 2000);
        this.uploadedFiles = [];
        this.Imageplayer = '';
        this.topplayersform.reset();
        this.onHighlightModalClose();
        //this.loadplayerlist();
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add Player failed', life: 6000 });
        this.onHighlightModalClose();
        this.topplayersform.reset();
        this.loadplayerlist();
      })
    );
  }
  updatePlayer(topplayerData) {
    this.playerservice.updateAcademyTopPlayers(this.playerid, topplayerData).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Player Updated', life: 6000 });
        setTimeout(() => {
          this.router.navigate(['/academies-profile/top-players']);
        }, 2000);
        this.uploadedFiles = [];
        this.Imageplayer = '';
        this.onHighlightModalClose();
        this.loadplayerlist();
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update Player failed', life: 6000 });
        this.onHighlightModalClose();
        this.topplayersform.reset();
        this.loadplayerlist();
      })
    );
  }
  onClickDelete(data) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this player?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let disableStatus;
        if (data.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        let updatedata = '{"disable":' + disableStatus + '}';
        this.playerservice.updateAcademyTopPlayers(data.id, updatedata).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Player Deleted', life: 3000 });
            this.loadplayerlist();
          },
          err => {
            this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: 'System Error. Please try again.', life: 3000 });
          }
        );
      },
      reject: () => {
        //this.getUserDetails(user.id);
      }
    });
  }
  public onIndexChange(index: number): void {
    //console.log('Swiper index: ', index);
  }

  public onSwiperEvent(event: string): void {
    //console.log('Swiper event: ', event);
  }

  public toggleKeyboardControl(): void {
    this.court_config.keyboard = !this.court_config.keyboard;
  }

  public toggleMouseWheelControl(): void {
    this.court_config.mousewheel = !this.court_config.mousewheel;
  }
}
